module.exports = __webpack_public_path__ + "static/media/R-300HD_CrossSection.92e8d8d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/en/R-300HD_CrossSection.png
// module id = 479
// module chunks = 0